import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../../constants/common'
import { AIButtonContainedGrey } from '../../../AIButton'
import Text from '../../../Text'
import { QA_NAME_GRETA_AI_CHAT_PROJECTS_RETRY } from '../../GretaAIChat.constants'

import * as styles from './GretaAIChatProjectsPageState.module.css'

function GretaAIChatProjectsPageState({
  text = EMPTY_STRING,
  title = EMPTY_STRING,
  onRetry = null,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.state}>
      <Text Element='p' className={styles.title}>
        {title}
      </Text>
      <Text isSecondary Element='p' className={styles.text}>
        {text}
      </Text>
      {onRetry ? (
        <AIButtonContainedGrey
          className={styles.retry}
          qaName={QA_NAME_GRETA_AI_CHAT_PROJECTS_RETRY}
          text={t('Greta.RetryButtonKey')}
          onClick={onRetry}
        />
      ) : null}
    </div>
  )
}

export default GretaAIChatProjectsPageState
